// extracted by mini-css-extract-plugin
export default {"emailList":"EmailListModal_emailList__bc6JI","emailListTitle":"EmailListModal_emailListTitle__u6w95","emailListContent":"EmailListModal_emailListContent__7WP95"};